<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>我的客户</h2>
        <p>
          这是员工最高频页面，支持筛选、快速跟进、编辑客户、延长保护期、转公海和转流失。
        </p>
      </div>
      <div class="crm-actions">
        <el-button type="primary" icon="el-icon-plus" @click="openEditor()"
          >新增客户</el-button
        >
        <el-button icon="el-icon-setting" @click="notifyPending('列设置')"
          >列设置</el-button
        >
      </div>
    </div>

    <el-card shadow="never">
      <el-row :gutter="12">
        <el-col :span="6"
          ><el-input
            v-model.trim="filters.keyword"
            placeholder="客户关键词搜索"
            clearable
          ></el-input
        ></el-col>
        <el-col :span="4"
          ><el-input
            v-model.trim="filters.phone"
            placeholder="手机号搜索"
            clearable
          ></el-input
        ></el-col>
        <el-col :span="4"
          ><el-input
            v-model.trim="filters.wechat"
            placeholder="微信号搜索"
            clearable
          ></el-input
        ></el-col>
        <el-col :span="4">
          <el-select
            v-model="filters.source"
            placeholder="来源筛选"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in options.sources"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="filters.intentionLevel"
            placeholder="意向等级"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in options.intentionLevels"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="2"
          ><el-button
            type="primary"
            icon="el-icon-search"
            style="width: 100%"
            @click="page = 1"
            >搜索</el-button
          ></el-col
        >
      </el-row>
      <el-row :gutter="12" style="margin-top: 12px">
        <el-col :span="4">
          <el-select
            v-model="filters.mainStatus"
            placeholder="主状态"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in options.mainStatuses"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="filters.subStatus"
            placeholder="子状态"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in options.subStatuses"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="filters.hasWeChat"
            placeholder="是否已加微信"
            clearable
            style="width: 100%"
          >
            <el-option label="已加微信" :value="true"></el-option>
            <el-option label="未加微信" :value="false"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="filters.publicRisk"
            placeholder="是否即将掉公海"
            clearable
            style="width: 100%"
          >
            <el-option label="即将掉公海" value="warning"></el-option>
            <el-option label="已超期" value="overdue"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4"
          ><el-date-picker
            v-model="filters.nextFollowDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="下次跟进时间"
            style="width: 100%"
          ></el-date-picker
        ></el-col>
        <el-col :span="4"
          ><el-button
            icon="el-icon-refresh-left"
            style="width: 100%"
            @click="resetFilters"
            >重置</el-button
          ></el-col
        >
      </el-row>
    </el-card>

    <div class="crm-tabs">
      <div
        v-for="item in quickTabs"
        :key="item.key"
        class="crm-tab"
        :class="{ active: quickKey === item.key }"
        @click="quickKey = item.key"
      >
        <span>{{ item.label }}</span>
        <b>{{ item.count }}</b>
      </div>
    </div>

    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>我的客户列表</span>
        <el-tag size="mini" type="info">前端 mock 演示</el-tag>
      </div>
      <el-table :data="pagedCustomers" stripe border>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column
          prop="name"
          label="客户姓名"
          min-width="120"
        ></el-table-column>
        <el-table-column label="手机号" min-width="160">
          <template slot-scope="scope">
            <crm-phone-field :phone="scope.row.phone" status="pending" />
          </template>
        </el-table-column>
        <el-table-column
          prop="wechat"
          label="微信号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="source"
          label="来源"
          width="100"
        ></el-table-column>
        <el-table-column prop="mainStatus" label="主状态" width="100">
          <template slot-scope="scope"
            ><el-tag size="mini" :type="statusType(scope.row.mainStatus)">{{
              scope.row.mainStatus
            }}</el-tag></template
          >
        </el-table-column>
        <el-table-column
          prop="subStatus"
          label="子状态"
          width="100"
        ></el-table-column>
        <el-table-column prop="intentionLevel" label="意向等级" width="110">
          <template slot-scope="scope"
            ><el-tag
              size="mini"
              :type="intentionType(scope.row.intentionLevel)"
              >{{ scope.row.intentionLevel }}</el-tag
            ></template
          >
        </el-table-column>
        <el-table-column prop="hasWeChat" label="已加微信" width="90">
          <template slot-scope="scope">{{
            scope.row.hasWeChat ? "是" : "否"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="lastFollowTime"
          label="最近跟进时间"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="nextFollowTime"
          label="下次跟进时间"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="publicPoolCountdown"
          label="距离掉公海"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="countdownType(scope.row.publicPoolCountdown)"
            >
              {{
                scope.row.publicPoolCountdown <= 0
                  ? "已超期"
                  : scope.row.publicPoolCountdown + " 天"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="260" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail(scope.row)"
              >查看详情</el-button
            >
            <el-button type="text" @click="openFollow(scope.row)"
              >快速跟进</el-button
            >
            <el-button type="text" @click="openEditor(scope.row)"
              >编辑客户</el-button
            >
            <el-button type="text" @click="openExtend(scope.row)"
              >申请延长保护期</el-button
            >
            <el-dropdown @command="handleCommand(scope.row, $event)">
              <el-button type="text"
                >更多<i class="el-icon-arrow-down el-icon--right"></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="wechat"
                  >标记已加微信</el-dropdown-item
                >
                <el-dropdown-item command="transfer">转移申请</el-dropdown-item>
                <el-dropdown-item command="public">转公海</el-dropdown-item>
                <el-dropdown-item command="lost">转流失</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="filteredCustomers.length"
          :page-size="pageSize"
          :current-page.sync="page"
        ></el-pagination>
      </div>
    </el-card>

    <crm-customer-drawer
      :visible.sync="detailVisible"
      :customer="selectedCustomer"
      @follow="openFollow"
      @edit="openEditor"
      @extend="openExtend"
      @public="moveToPublic"
      @lost="moveToLost"
    />

    <crm-follow-dialog
      :visible.sync="followVisible"
      :customer="selectedCustomer"
      :value="followForm"
      @submit="submitFollow"
    />

    <el-dialog
      :visible.sync="editorVisible"
      :title="editorForm.id ? '编辑客户' : '新增客户'"
      width="540px"
      :append-to-body="true"
    >
      <el-row :gutter="12">
        <el-col :span="12"
          ><el-input v-model="editorForm.name" placeholder="客户姓名"></el-input
        ></el-col>
        <el-col :span="12"
          ><el-input v-model="editorForm.phone" placeholder="手机号"></el-input
        ></el-col>
      </el-row>
      <el-row :gutter="12" style="margin-top: 12px">
        <el-col :span="12"
          ><el-input v-model="editorForm.wechat" placeholder="微信号"></el-input
        ></el-col>
        <el-col :span="12"
          ><el-input
            v-model="editorForm.companyName"
            placeholder="公司名称"
          ></el-input
        ></el-col>
      </el-row>
      <el-row :gutter="12" style="margin-top: 12px">
        <el-col :span="12">
          <el-select
            v-model="editorForm.source"
            placeholder="来源"
            style="width: 100%"
          >
            <el-option
              v-for="item in options.sources"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-select
            v-model="editorForm.intentionLevel"
            placeholder="意向等级"
            style="width: 100%"
          >
            <el-option
              v-for="item in options.intentionLevels"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-input
        type="textarea"
        :rows="3"
        style="margin-top: 12px"
        v-model="editorForm.remark"
        placeholder="备注"
      ></el-input>
      <span slot="footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEditor">保存客户</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="extendVisible"
      title="延长保护期申请"
      width="460px"
      :append-to-body="true"
    >
      <el-input-number
        v-model="extendForm.days"
        :min="1"
        :max="30"
        label="延长天数"
      ></el-input-number>
      <el-input
        type="textarea"
        :rows="4"
        style="margin-top: 12px"
        v-model="extendForm.reason"
        placeholder="申请原因"
      ></el-input>
      <span slot="footer">
        <el-button @click="extendVisible = false">取消</el-button>
        <el-button type="primary" @click="submitExtend">提交申请</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CrmCustomerDrawer from "./CustomerDrawer.vue";
import CrmFollowDialog from "./FollowDialog.vue";
import CrmPhoneField from "./PhoneField.vue";
import {
  CRM_OPTIONS,
  createCustomerId,
  createOperationLog,
  loadCrmState,
  normalizePhone,
  saveCrmState,
} from "./mock";

export default {
  name: "CrmMyCustomers",
  components: { CrmCustomerDrawer, CrmFollowDialog, CrmPhoneField },
  data() {
    return {
      options: CRM_OPTIONS,
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      filters: {
        keyword: "",
        phone: "",
        wechat: "",
        source: "",
        intentionLevel: "",
        mainStatus: "",
        subStatus: "",
        hasWeChat: "",
        publicRisk: "",
        nextFollowDate: "",
      },
      quickKey: "all",
      page: 1,
      pageSize: 8,
      detailVisible: false,
      followVisible: false,
      editorVisible: false,
      extendVisible: false,
      selectedCustomer: null,
      followForm: {
        method: "电话",
        result: "有效沟通",
        summary: "",
        valid: true,
        hasWeChat: false,
        nextFollowTime: "",
      },
      editorForm: {
        id: "",
        name: "",
        phone: "",
        wechat: "",
        companyName: "",
        source: "抖音",
        intentionLevel: "C低意向",
        remark: "",
      },
      extendForm: { days: 3, reason: "" },
    };
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(value) {
        const allowTabs = [
          "all",
          "todayFollow",
          "todayAssigned",
          "wechat",
          "highIntent",
          "awaitSign",
          "overdue",
          "toPublic",
        ];
        this.quickKey = allowTabs.includes(value) ? value : "all";
        this.page = 1;
      },
    },
  },
  computed: {
    ownerName() {
      return this.$store.getters.GET_TITLE || "当前员工";
    },
    myCustomers() {
      return this.state.customers.filter(
        (item) =>
          item.poolType === "私人池" && item.ownerName === this.ownerName
      );
    },
    filteredCustomersBase() {
      return this.myCustomers.filter((item) => {
        if (
          this.filters.keyword &&
          `${item.name}${item.companyName}${(item.tags || []).join(
            ""
          )}`.indexOf(this.filters.keyword) === -1
        )
          return false;
        if (
          this.filters.phone &&
          String(item.phone).indexOf(this.filters.phone) === -1
        )
          return false;
        if (
          this.filters.wechat &&
          String(item.wechat || "").indexOf(this.filters.wechat) === -1
        )
          return false;
        if (this.filters.source && item.source !== this.filters.source)
          return false;
        if (
          this.filters.intentionLevel &&
          item.intentionLevel !== this.filters.intentionLevel
        )
          return false;
        if (
          this.filters.mainStatus &&
          item.mainStatus !== this.filters.mainStatus
        )
          return false;
        if (this.filters.subStatus && item.subStatus !== this.filters.subStatus)
          return false;
        if (
          this.filters.hasWeChat !== "" &&
          item.hasWeChat !== this.filters.hasWeChat
        )
          return false;
        if (
          this.filters.publicRisk === "warning" &&
          !(item.publicPoolCountdown > 0 && item.publicPoolCountdown <= 2)
        )
          return false;
        if (
          this.filters.publicRisk === "overdue" &&
          item.publicPoolCountdown > 0
        )
          return false;
        if (
          this.filters.nextFollowDate &&
          !String(item.nextFollowTime || "").startsWith(
            this.filters.nextFollowDate
          )
        )
          return false;
        return true;
      });
    },
    filteredCustomers() {
      return this.filteredCustomersBase.filter((item) => {
        if (this.quickKey === "todayFollow")
          return this.isToday(item.nextFollowTime);
        if (this.quickKey === "todayAssigned")
          return this.isToday(item.enteredAt);
        if (this.quickKey === "wechat") return item.hasWeChat;
        if (this.quickKey === "highIntent")
          return item.intentionLevel === "A高意向";
        if (this.quickKey === "awaitSign") return item.mainStatus === "待签约";
        if (this.quickKey === "overdue") return item.publicPoolCountdown <= 0;
        if (this.quickKey === "toPublic")
          return item.publicPoolCountdown > 0 && item.publicPoolCountdown <= 2;
        return true;
      });
    },
    pagedCustomers() {
      const start = (this.page - 1) * this.pageSize;
      return this.filteredCustomers.slice(start, start + this.pageSize);
    },
    quickTabs() {
      const list = this.filteredCustomersBase;
      const count = (fn) => list.filter(fn).length;
      return [
        { key: "all", label: "全部", count: list.length },
        {
          key: "todayFollow",
          label: "今日待跟进",
          count: count((item) => this.isToday(item.nextFollowTime)),
        },
        {
          key: "todayAssigned",
          label: "今日新分配",
          count: count((item) => this.isToday(item.enteredAt)),
        },
        {
          key: "wechat",
          label: "已加微信",
          count: count((item) => item.hasWeChat),
        },
        {
          key: "highIntent",
          label: "高意向",
          count: count((item) => item.intentionLevel === "A高意向"),
        },
        {
          key: "awaitSign",
          label: "待签约",
          count: count((item) => item.mainStatus === "待签约"),
        },
        {
          key: "overdue",
          label: "超期未跟进",
          count: count((item) => item.publicPoolCountdown <= 0),
        },
        {
          key: "toPublic",
          label: "即将转公海",
          count: count(
            (item) =>
              item.publicPoolCountdown > 0 && item.publicPoolCountdown <= 2
          ),
        },
      ];
    },
  },
  methods: {
    reloadState() {
      this.state = loadCrmState(this.ownerName);
    },
    persistState() {
      saveCrmState(this.state);
      this.reloadState();
    },
    resetFilters() {
      this.filters = {
        keyword: "",
        phone: "",
        wechat: "",
        source: "",
        intentionLevel: "",
        mainStatus: "",
        subStatus: "",
        hasWeChat: "",
        publicRisk: "",
        nextFollowDate: "",
      };
      this.quickKey = "all";
      this.page = 1;
      if (this.$route.query.tab) {
        this.$router
          .replace({ path: this.$route.path, query: {} })
          .catch(() => {});
      }
    },
    notifyPending(action) {
      this.$message.warning(`${action}为预留功能，后续开发`);
    },
    isToday(value) {
      return (
        value && String(value).startsWith(new Date().toISOString().slice(0, 10))
      );
    },
    statusType(status) {
      const map = {
        跟进中: "primary",
        已加微信: "success",
        待签约: "danger",
        已签约: "success",
        已流失: "info",
        公海池: "warning",
        新录入: "",
      };
      return map[status] || "info";
    },
    intentionType(level) {
      const map = {
        A高意向: "danger",
        B中意向: "warning",
        C低意向: "info",
        D无意向: "",
        X无效: "info",
      };
      return map[level] || "info";
    },
    countdownType(days) {
      if (days <= 0) return "danger";
      if (days <= 2) return "warning";
      return "success";
    },
    openDetail(customer) {
      this.selectedCustomer = customer;
      this.detailVisible = true;
    },
    openFollow(customer) {
      this.selectedCustomer = customer;
      this.followForm = {
        method: "电话",
        result: "有效沟通",
        summary: "",
        valid: true,
        hasWeChat: customer.hasWeChat,
        nextFollowTime: customer.nextFollowTime || "",
      };
      this.followVisible = true;
    },
    submitFollow(form) {
      const target = this.state.customers.find(
        (item) => item.id === this.selectedCustomer.id
      );
      if (!target) return;
      const now = new Date();
      const time = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(now.getDate()).padStart(2, "0")} ${String(
        now.getHours()
      ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
      target.lastFollowTime = time;
      target.nextFollowTime = form.nextFollowTime;
      target.hasWeChat = form.hasWeChat;
      target.firstCallDone = true;
      target.firstCallResult = form.result;
      target.mainStatus =
        form.result === "已预约"
          ? "已预约"
          : form.result === "已报价"
          ? "已报价"
          : form.result === "已加微信"
          ? "已加微信"
          : "跟进中";
      target.subStatus = form.result;
      target.timeline = target.timeline || [];
      target.timeline.unshift({
        time,
        type: form.method,
        title: form.result,
        desc: form.summary,
        operator: this.ownerName,
      });
      this.state.followRecords.unshift({
        id: `FR${Date.now()}`,
        customerId: target.id,
        customerName: target.name,
        employeeName: this.ownerName,
        followTime: time,
        method: form.method,
        result: form.result,
        summary: form.summary,
        valid: form.valid,
        hasWeChat: form.hasWeChat,
        nextFollowTime: form.nextFollowTime,
        qcStatus: "待质检",
        hasAttachment: false,
      });
      this.state.operationLogs.unshift(
        createOperationLog(
          this.ownerName,
          "跟进记录",
          "新增跟进",
          target.name,
          `${form.method}跟进`,
          "成功",
          form.summary
        )
      );
      this.persistState();
      this.followVisible = false;
      this.$message.success("已完成一次电话/微信跟进（前端演示）");
    },
    openEditor(customer) {
      this.selectedCustomer = customer || null;
      this.editorForm = customer
        ? { ...customer }
        : {
            id: "",
            name: "",
            phone: "",
            wechat: "",
            companyName: "",
            source: "抖音",
            intentionLevel: "C低意向",
            remark: "",
          };
      this.editorVisible = true;
    },
    saveEditor() {
      if (!this.editorForm.name || !this.editorForm.phone)
        return this.$message.warning("客户姓名和手机号必填");
      const phone = normalizePhone(this.editorForm.phone);
      const existed = this.state.customers.find(
        (item) =>
          normalizePhone(item.phone) === phone && item.id !== this.editorForm.id
      );
      if (existed)
        return this.$message.warning(
          "检测到手机号重复，当前仅演示重复提醒逻辑"
        );
      if (this.editorForm.id) {
        const index = this.state.customers.findIndex(
          (item) => item.id === this.editorForm.id
        );
        if (index > -1)
          this.state.customers.splice(index, 1, { ...this.editorForm });
      } else {
        this.state.customers.unshift({
          ...this.editorForm,
          id: createCustomerId(this.state),
          ownerName: this.ownerName,
          poolType: "私人池",
          mainStatus: "新录入",
          subStatus: "未接通",
          hasWeChat: false,
          tags: ["新增客户"],
          businessTags: [],
          riskTags: [],
          manageTags: [],
          customTags: [],
          publicPoolCountdown: 7,
          enteredAt: new Date().toISOString().slice(0, 16).replace("T", " "),
          timeline: [],
          attachments: [],
          wechatProgress: {
            sentRequest: false,
            approved: false,
            approvedAt: "",
            sentCase: false,
            sentQuote: false,
            sentCompanyIntro: false,
          },
        });
      }
      this.state.operationLogs.unshift(
        createOperationLog(
          this.ownerName,
          "客户管理CRM",
          this.editorForm.id ? "编辑客户" : "新增客户",
          this.editorForm.name,
          "客户资料维护",
          "成功",
          ""
        )
      );
      this.persistState();
      this.editorVisible = false;
      this.$message.success("客户资料已保存（前端 mock）");
    },
    openExtend(customer) {
      this.selectedCustomer = customer;
      this.extendForm = { days: 3, reason: "" };
      this.extendVisible = true;
    },
    submitExtend() {
      if (!this.extendForm.reason)
        return this.$message.warning("请填写申请原因");
      this.state.approvals.unshift({
        id: `AP${Date.now()}`,
        createdAt: new Date().toISOString().slice(0, 16).replace("T", " "),
        applicant: this.ownerName,
        customerName: this.selectedCustomer.name,
        type: "延长保护期申请",
        reason: `${this.extendForm.reason}（申请延长 ${this.extendForm.days} 天）`,
        status: "待审批",
        approver: "销售主管",
      });
      this.state.operationLogs.unshift(
        createOperationLog(
          this.ownerName,
          "客户管理CRM",
          "提交审批",
          this.selectedCustomer.name,
          "延长保护期申请",
          "成功",
          this.extendForm.reason
        )
      );
      this.persistState();
      this.extendVisible = false;
      this.$message.success("延长保护期申请已提交到审批中心（前端演示）");
    },
    handleCommand(customer, command) {
      if (command === "wechat") return this.markWechat(customer);
      if (command === "transfer") return this.notifyPending("客户归属转移申请");
      if (command === "public") return this.moveToPublic(customer);
      if (command === "lost") return this.moveToLost(customer);
    },
    markWechat(customer) {
      const target = this.state.customers.find(
        (item) => item.id === customer.id
      );
      if (!target) return;
      target.hasWeChat = true;
      target.mainStatus = "已加微信";
      target.subStatus = "有意向";
      target.wechatProgress.sentRequest = true;
      target.wechatProgress.approved = true;
      target.wechatProgress.approvedAt = new Date()
        .toISOString()
        .slice(0, 16)
        .replace("T", " ");
      this.persistState();
      this.$message.success("已标记为已加微信（前端演示）");
    },
    moveToPublic(customer) {
      const target = this.state.customers.find(
        (item) => item.id === customer.id
      );
      if (!target) return;
      target.lastOwnerName = target.ownerName;
      target.ownerName = "";
      target.poolType = "公海池";
      target.mainStatus = "公海池";
      target.publicReason = "手动转公海";
      target.publicAt = new Date().toISOString().slice(0, 16).replace("T", " ");
      this.persistState();
      this.$message.success("客户已转入公海池（前端演示）");
    },
    moveToLost(customer) {
      const target = this.state.customers.find(
        (item) => item.id === customer.id
      );
      if (!target) return;
      target.mainStatus = "已流失";
      target.subStatus = "无意向";
      target.intentionLevel = "D无意向";
      target.lostReason = "暂不考虑";
      this.persistState();
      this.$message.success("客户已转流失（前端演示）");
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.crm-tabs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.crm-tab {
  min-width: 118px;
  padding: 12px 16px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #e8edf5;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.crm-tab.active {
  background: #eff6ff;
  color: #409eff;
  border-color: #409eff;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pager {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
